<template>
  <div>
    <div
      class="site-wrapper"
      :class="touchEventClass"
    >
      <transition
        name="fade"
        mode="out-in"
      >
        <v-app>
          <PolygonLoader v-if="!loaded" :size="100" key="loading" />
          <div v-else key="loaded" class="site-wrapper__container" >
              <PolygonDrawer :drawer="drawer" />
              <PolygonToolbar @toggle-drawer="toggleDrawer" />
              <PolygonContent />
              <PolygonFooter />
          </div>
          <!-- Where is this dialog used? -->
          <v-dialog />
        </v-app>
      </transition>
    </div>
  </div>
</template>

<script>
import { loadApp } from '@/core/startup'

export default {
  data: () => ({
    loaded: false,
    drawer: true
  }),
  mounted() {
    loadApp().done(() => {
      setTimeout(() => {
        this.loaded = true
      }, 500)
    })
  },
  computed: {
    touchEventClass() {
      /* eslint-disable no-undef */
      const hasTouchSupport =
        'ontouchstart' in window ||
        (window.DocumentTouch && document instanceof DocumentTouch)
      /* eslint-enable no-undef */
      return hasTouchSupport ? 'touch' : 'no-touch'
    }
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer
    }
  }
}
</script>
